module.exports = __webpack_public_path__ + "static/medical_companion_screenani.2def0894.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/articles/dsk-companion/medical_companion_screenani.mp4
// module id = 335
// module chunks = 104555942287938